module.exports = __webpack_public_path__ + "img/caret-up.67a26158.svg";